// src/pages/UserLogin/UserLogin.jsx
import React, { useState, useContext } from "react";
import axios from "axios";
import "./UserLogin.css";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../apiConfig";

function UserLogin() {
  // For students, we’re using studentID and name for login.
  const [studentID, setStudentID] = useState("");
  const [name, setName] = useState("");
  
  // Use setAuthState (which expects an object with isAuthenticated and role)
  const { setAuthState } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Post credentials to the student login endpoint
      const response = await axios.post(
        `${API_BASE_URL}/student/login`,
        { studentID, name },
        { withCredentials: true }
      );
      
      // On success, mark the user as authenticated with the "student" role.
      if (response.status === 200) {
        setAuthState({ isAuthenticated: true, role: "student" });
        navigate("/signedInStudent");
      } else {
        alert("Login failed: " + response.data.message);
      }
    } catch (error) {
      console.error("Login error:", error);
      alert(
        "Login failed: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="user-login-container">
      <form className="user-login-form" onSubmit={handleLogin}>
        <h2>User Login</h2>
        <label>
          Student ID:
          <input
            type="text"
            value={studentID}
            onChange={(e) => setStudentID(e.target.value)}
            required
          />
        </label>
        <br />
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <br />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default UserLogin;
